import { hashEmail } from '@on3/ui-lib/utils/user';
import { getCookie } from '@public/utils/tracking';
import { type Checkout } from '@public/utils/tracking/types';

const FB_PIXEL_ACCESS_CODE =
  'EAAT3esltZAXwBO9nQkuzeYU7D6AOnQ3DJjHVIvGPNexFdCBmQ4LmSvi5cISES9i2aGqkVTEd4FFjgUZAiYFIUqTpXljXlTs4HD8BFjEZARadwOphdkEqDSOPrZBiXVNkxX0XmmldkL4aKPMNq8EZCrj9o08raJYE91Vtw2vmSDpj7Hl5wZCPiVZA3ZArFtPDtJeliQZDZD';
const FB_PIXEL_ID = '1548897892509790';
const FB_PIXEL_API_VERSION = 'v20.0';

const trackFbPurchase = async (
  userKey: string | number,
  userEmail: string,
  userIp: string,
  conversion: Checkout,
) => {
  const encodedEmail: string | null = userEmail
    ? await hashEmail(userEmail)
    : null;

  const userAgent = navigator.userAgent;
  const fbc = getCookie('_fbc');
  const fbp = getCookie('_fbp');

  const data = {
    event_name: 'Purchase',
    event_time: Math.floor(Date.now() / 1000),
    action_source: 'website',
    user_data: {
      em: [encodedEmail],
      client_ip_address: userIp,
      client_user_agent: userAgent,
      fbc,
      fbp,
      external_id: userKey,
    },
    custom_data: {
      ...conversion,
      value: conversion.total,
      currency: 'USD',
    },
  };

  try {
    await fetch(
      `https://graph.facebook.com/${FB_PIXEL_API_VERSION}/${FB_PIXEL_ID}/events?access_token=${FB_PIXEL_ACCESS_CODE}`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: [data] }),
      },
    );
  } catch (error) {
    // Fail silently
  }
};

export { trackFbPurchase };
